import { check_for_pause, cue_log } from './utils/cue_utils';
import resetInteractions from './utils/sl_reset_interactions.js';

export function add_chapters(player, chapters) {
  IVP.log(`[add_chapters]: Adding chapters`, 'info');
  // Create blob from chapters string
  const vttChapters = new Blob([chapters], {
    type: 'text/plain',
  });

  // Log chapters to console
  vttChapters.text().then((text) => {
    IVP.log(`[add_chapters]: vttChapters.text: ${text}`, 'info');
  });

  // Create URL from Blob
  const vttUrl = URL.createObjectURL(vttChapters);

  // Add chapters to player
  const chaptersTrackEl = player.addRemoteTextTrack({
    label: 'chapters',
    kind: 'chapters',
    src: vttUrl,
    mode: 'visible',
  });

  chaptersTrackEl.addEventListener('load', function () {
    // the object has a reference to the TextTrack object via the `track` property
    IVP.log(`[add_chapters]: Chapters track added successfully.`, 'ok');

    // Add a listener for the "cuechange" event for the chapters track
    chaptersTrackEl.addEventListener('cuechange', function (e) {
      // Unused..
    });
  });
}

export function add_interactions(player, interactions) {
  IVP.log(`[add_interactions]: Adding interactions`, 'info');
  // Create blob from interactions string
  const vttInteractions = new Blob([interactions], {
    type: 'text/plain',
  });

  // Log interactions to console
  vttInteractions.text().then((text) => {
    IVP.log(`[add_interactions]: vttInteractions.text: ${text}`, 'info');
  });

  // Create URL from Blob
  const vttUrl = URL.createObjectURL(vttInteractions);

  // Add interactions track to player
  const interactionsTrackEl = player.addRemoteTextTrack({
    label: 'interactions',
    kind: 'metadata',
    src: vttUrl,
    mode: 'hidden',
  });

  interactionsTrackEl.addEventListener('load', function () {
    // the object has a reference to the TextTrack object via the `track` property
    IVP.log(`[add_interactions]: Interactions track added successfully.`, 'ok');

    // Reference interactions track
    const track = interactionsTrackEl.track;

    // Set reference to keep track of current cue
    let currentCue = null;

    // Add a listener for the "cuechange" event for the interactions track
    track.addEventListener('cuechange', function (e) {
      if (track.activeCues[0] !== undefined) {
        currentCue = track.activeCues[0];
        if (currentCue.id != SL.get('vtInteraction')) {
          IVP.log(`[INTERACTION START: ${currentCue.id}]`, 'action');
          cue_log(currentCue);
          if (check_for_pause(currentCue)) {
            IVP.log('Pausing', 'action');
            SL.set('vtPlayToggle', false);
          }
          SL.set('vtInteraction', currentCue.id);
        } else {
          IVP.log(`[add_interactions > cuechange]: Skipping active cue ${currentCue.id}]`, 'action');
        }
      } else {
        IVP.log(`[INTERACTION END: ${currentCue.id}]`, 'action');
        SL.set('vtInteractionOut', currentCue.id);
        resetInteractions();
      }
    });
  });
}

export function add_completion(player, completion) {
  IVP.log(`[add_completion]: Adding completion`, 'info');
  // Create blob from completion string
  const vttCompletion = new Blob([completion], {
    type: 'text/plain',
  });

  // Log completion to console
  vttCompletion.text().then((text) => {
    IVP.log(`[add_completion]: vttCompletion.text: ${text}`, 'info');
  });

  // Create URL from Blob
  const vttUrl = URL.createObjectURL(vttCompletion);

  // Add completion to player
  const completionTrackEl = player.addRemoteTextTrack({
    label: 'completion',
    kind: 'metadata',
    src: vttUrl,
    mode: 'hidden',
  });

  completionTrackEl.addEventListener('load', function () {
    // the object has a reference to the TextTrack object via the `track` property
    IVP.log(`[add_completion]: Completion track added successfully.`, 'ok');

    // Reference completion track
    const track = completionTrackEl.track;

    // Add a listener for the "cuechange" event for the completion track
    track.addEventListener('cuechange', function (e) {
      if (track.activeCues[0] !== undefined) {
        const currentCue = track.activeCues[0];
        IVP.log(`[COMPLETION REACHED: ${currentCue.id}]`, 'action');
        cue_log(currentCue);
        SL.set('vtCompleted', true);
      }
    });
  });
}
